"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getProductImpressionsTemplate = function getProductImpressionsTemplate() {
  return {
    _telus: {
      productImpressions: {
        value: 1
      }
    }
  };
};
var _default = exports["default"] = getProductImpressionsTemplate;